export default class InputGetShipping
{
  constructor(shipping) 
  {
    this.shipping = shipping
  }    
}